import { sanitizeRichHtml } from "@lib/sanitizeHtml"
import * as m from "@paraglide/messages"
import type { ContentImage, SupportedLocale as Lang } from "@site-types/site"
import { imageDimensions, imageSizes, imageSrcSet, imageUrl } from "../../componentUtils"
import ScrollArrow from "../ScrollArrow"
import "./styles.css"

export function Agency({ gamersImage, locale }: { gamersImage?: ContentImage; locale: Lang }) {
  return (
    <section
      className="agency scroll-area"
      id="agency"
    >
      {gamersImage ? (
        <img
          className="gamers"
          src={imageUrl(gamersImage, "workModal")}
          srcSet={imageSrcSet(gamersImage, "workModal")}
          sizes={imageSizes("workModal")}
          alt="company culture"
          {...imageDimensions(gamersImage)}
        />
      ) : null}
      <div className="copy">
        <h2>{m.home_agency_title({}, { locale: locale })}</h2>
        <p>
          <strong
            dangerouslySetInnerHTML={{
              __html: sanitizeRichHtml(m.home_agency_pointOneBold({}, { locale: locale })),
            }}
          />
          <br />
          {m.home_agency_pointOne({}, { locale: locale })}
        </p>
        <p>
          <strong>{m.home_agency_pointTwoBold({}, { locale: locale })}</strong>
          <br />
          {m.home_agency_pointTwo({}, { locale: locale })}
        </p>
        <p>
          <strong>{m.home_agency_pointThreeBold({}, { locale: locale })}</strong>
          <br />
          {m.home_agency_pointThree({}, { locale: locale })}
        </p>
        <a
          className="work-link"
          href={`/${locale}/work`}
          dangerouslySetInnerHTML={{
            __html: sanitizeRichHtml(m.home_agency_pointFour({}, { locale: locale })),
          }}
        />
      </div>
      <ScrollArrow
        href="#brands"
        label="Scroll to brands"
      />
    </section>
  )
}

export default Agency
